import { ElectedInfo } from "../../../../src/components/electeds/elected-info.js";
import Peskin from "../../../../content/people/aaron-peskin/peskin.js";
import * as React from 'react';
export default {
  ElectedInfo,
  Peskin,
  React
};